<template>
    <div class="user-picker">
        <supsis-table
            :columns="cols"
            :rows="users"
            :bottom-pagination="true"
            :pagination-cursor="paginationCursor"
            :options="tableOptions"
            @cursor-changed="(cursor) => (paginationCursor = cursor)"
            class="users-supsis-table"
        >
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <a-input-search
                            :value="searchText"
                            @input="searchTextHandle($event)"
                            :placeholder="$t('message.startFilter')"
                            class="search-input"
                            @search="onSearch"
                        />
                    </div>
                </div>
            </template>
        </supsis-table>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import SupsisTable from "../../../../../components/SupsisTable.vue";
import AgentAvatar from "../../../../../components/common/AgentAvatar.vue";

export default Vue.extend({
    name: "UserPicker",
    components: {
        SupsisTable,
        AgentAvatar,
    },
    data() {
        return {
            searchText: "",
            paginationCursor: {
                total: 0,
                page: 1,
                perPage: 10,
            },
            tableOptions: {
                rowKey: "_id",
                bordered: true,
                size: "middle",
            },
        };
    },
    computed: {
        users() {
            const searchLower = this.searchText.toLowerCase();
            if (searchLower === "") {
                return this.$store.state.user.users.data;
            }
            return this.$store.state.user.users.data.filter((user) => {
                return (
                    user.name.toLowerCase().includes(searchLower) ||
                    user.email.toLowerCase().includes(searchLower)
                );
            });
        },
        cols() {
            return [
                {
                    field: "avatar",
                    key: "avatar",
                    title: "",
                    renderBodyCell: ({ row }) => {
                        return this.$createElement(AgentAvatar, {
                            props: {
                                userID: row._id,
                                size: 30,
                            },
                        });
                    },
                },
                {
                    field: "name",
                    key: "name",
                    title: this.$t("message.name"),
                },
                {
                    field: "email",
                    key: "email",
                    title: this.$t("message.email"),
                },
                {
                    field: "action",
                    key: "action",
                    title: this.$t("message.action"),
                    renderBodyCell: ({ row }) => {
                        return this.$createElement(
                            "a-button",
                            {
                                on: {
                                    click: () => this.onSelect(row),
                                },
                            },
                            "Seç"
                        );
                    },
                },
            ];
        },
    },
    created() {
        this.fetchUsers({
            perPage: 1000,
            page: 1,
            query: "",
            updateStore: false,
        });
    },
    methods: {
        ...mapActions({
            fetchUsers: "user/getUsers",
        }),
        searchTextHandle(e) {
            this.searchText = e.target.value;
        },
        onSearch() {
            // Artık computed property otomatik olarak filtreleme yapacak
        },
        onSelect(user) {
            this.$emit("user-selected", user);
        },
    },
});
</script>

<style scoped lang="scss">
.user-picker {
    .search-input {
        max-width: 300px;
    }
}
</style>
